<div>
  <mat-tab-group>
    <mat-tab [label]="'PAGES.BACKUPS.TABS.PRODUCTION' | translate">
      <ng-template matTabContent>
        <app-staging-from-backup-table
          [isStaging]="false"
          [parentDialogRef]="dialogRef"
        ></app-staging-from-backup-table>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="'PAGES.BACKUPS.TABS.STAGING' | translate">
      <ng-template matTabContent>
        <app-staging-from-backup-table
          [isStaging]="true"
          [parentDialogRef]="dialogRef"
        ></app-staging-from-backup-table>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
